import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 削除済みです ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "トレーニングに戻る", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "text-right mb10" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("削除")

import { useRoute, useRouter } from 'vue-router'
import { computed, onMounted, ref, watch } from "vue";
import LearningCourseForm from "@/components/learning/LearningCourseForm.vue";
import { LearningCourseLogic } from "@/logic/learning/LearningCourseLogic";
import { LearningCategoryLogic } from "@/logic/learning/LearningCategoryLogic";
import { QuestionCategoryLogic } from "@/logic/question/QuestionCategoryLogic";
import { useChangeCategoryForm } from "@/logic/learning_course/ChangeCategoryFormLogic";
import { useExceptionMessage } from '@/logic/ExceptionMessageLogic';
import { QusitionState } from "@/state/QusitionState";
import { LearningCategory } from '@/types/learning_category'
// 暫定でここでリポジトリ呼び出し

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { learningCourse, learningForms,
  learningCourseLoading,
  getLearningCourse,
  getRandQuestion,
  addLearningForm,
  removeLearningForm,
  syncLearningForm,
  update: updateLogic,
  up, down,
  deleteLearningCourse,
  addAnswerFrom,
  removeAnswerForm, setQuillRef } = LearningCourseLogic();
const { changeCategory } = useChangeCategoryForm(Number(route.params.project_id));
const { loadQuestionCategories, questionCategoryLoading } = QuestionCategoryLogic();
const { learningCategories, loadLearningCategories, learningCategoryLoading } = LearningCategoryLogic();
const questionCategories = computed(() => QusitionState.state.questionCategories);
const deleted = ref(false)
const projectId = computed(() => Number(route.params.project_id));
const learningCourseId = computed(() => Number(route.params.learning_course_id));
const disableDestroy = computed(() => {
  if (learningForms.value.length > 0) {
    return true
  }
  return false;
});
const deleteAndClear = async () => {
  await deleteLearningCourse(learningCourseId.value)
  deleted.value = true
}
onMounted(async (): Promise<void> => {
  getLearningCourse(projectId.value, learningCourseId.value)
  QusitionState.setProjectId(projectId.value);
  loadQuestionCategories();
  loadLearningCategories();
});

const categoryName = ref('');
watch(learningCourse, (learningCourse) => {
  if (learningCourse.category) {
    categoryName.value = learningCourse.category.name;
  }
});

const moveCategoryDialogVisible = ref(false)
const handleMoveCategoryDialogVisible = (visible: boolean) => {
  moveCategoryDialogVisible.value = visible;
};
const handleUpdateCategory = (category: LearningCategory) => {
  if (category.id === 0) {
    return;
  }

  try {
    changeCategory(Number(route.params.learning_course_id), category.id);
    categoryName.value = category.name;
    handleMoveCategoryDialogVisible(false)
  } catch (e) {
    useExceptionMessage(e);
  }
};

const update = async () => {
  if (await updateLogic()) {
    router.push({name: 'ProjectLearningCourseShow'});
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (deleted.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_router_link, {
            to: { name: 'ProjectLearningCourseList', params: { project_id: _ctx.$route.params.project_id } }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { size: 18 }),
              _hoisted_3
            ]),
            _: 1
          }, 8, ["to"])
        ], 512)), [
          [_directive_loading, _unref(learningCourseLoading)]
        ])
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteAndClear())),
                disabled: _unref(disableDestroy)
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createVNode(LearningCourseForm, {
              modelValue: _unref(learningCourse).name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(learningCourse).name) = $event)),
              categoryName: categoryName.value,
              learningForms: _unref(learningForms),
              learningCategories: _unref(learningCategories),
              questionCategories: _unref(questionCategories),
              moveCategoryDialogVisible: moveCategoryDialogVisible.value,
              onSetQuillRef: _unref(setQuillRef),
              onAddLearningForm: _unref(addLearningForm),
              onRemoveLearningForm: _unref(removeLearningForm),
              onAddAnswerFrom: _unref(addAnswerFrom),
              onRemoveAnswerForm: _unref(removeAnswerForm),
              onGetRandQuestion: _unref(getRandQuestion),
              onSyncLearningForm: _unref(syncLearningForm),
              onUp: _unref(up),
              onDown: _unref(down),
              onSave: update,
              "onUpdate:category": handleUpdateCategory,
              "onUpdate:moveCategoryDialogVisible": handleMoveCategoryDialogVisible,
              formType: "edit"
            }, null, 8, ["modelValue", "categoryName", "learningForms", "learningCategories", "questionCategories", "moveCategoryDialogVisible", "onSetQuillRef", "onAddLearningForm", "onRemoveLearningForm", "onAddAnswerFrom", "onRemoveAnswerForm", "onGetRandQuestion", "onSyncLearningForm", "onUp", "onDown"])
          ], 512), [
            [_directive_loading, _unref(learningCourseLoading) || _unref(questionCategoryLoading) || _unref(learningCategoryLoading)]
          ])
        ]))
  ]))
}
}

})